document.addEventListener('DOMContentLoaded', function() {

  document.querySelectorAll('form.button input[type=file]').forEach(function(el) {
    el.addEventListener('change', function(e) {
      var form = el.parentNode;
      form.submit();
    });
  });

});
